import { v4 as uuidv4 } from 'uuid';
import type { CardProps } from 'src/notifications/cardTypes';
import NotificationCardShell from '../NotificationCardShell';
import NotificationDetailRow from '../NotificationDetailRow';
import NotificationLinkButton from '../NotificationLinkButton';

export default function DetectionUnreviewedCard({
  notification,
  payload,
  onClose,
}: CardProps<'DETECTION_UNREVIEWED'>) {
  return (
    <NotificationCardShell
      notification={notification}
      title="Detected data not reviewed"
      body="An uploaded document has detected data that has not been reviewed."
      clientId={payload.client_id}
      details={
        payload.file_name && <NotificationDetailRow label="File" value={payload.file_name} />
      }
      actions={
        <>
          <NotificationLinkButton
            to={`/client/${payload.client_id}/document/add`}
            onClose={onClose}
          >
            View
          </NotificationLinkButton>
          <NotificationLinkButton
            primary
            to={`/client/${payload.client_id}/detected-entities?fileId=${payload.data_upload_file_id}&fileName=${encodeURIComponent(payload.file_name ?? '')}&guid=${uuidv4()}`}
            onClose={onClose}
          >
            Review
          </NotificationLinkButton>
        </>
      }
    />
  );
}
